export default __webpack_public_path__ + "static/home-header-example-cbedfc174ea24315c91c4509fd1b93e3.jpg";